import { gql } from "@apollo/client";

export const GET_ACCOUNT_STACKS = gql`
  query GetAccountStacks {
    hasAnsibleStacks
  }
`;
